document.addEventListener("DOMContentLoaded", function () {
    function initializeSwipers() {
        if (window.innerWidth <= 991) {
            const carousels = document.querySelectorAll('.swiper-container');
            carousels.forEach((carousel) => {
                const swiper = new Swiper(carousel, {
                    slidesPerView: 1,
                    loop: true,
                    pagination: {
                        el: carousel.querySelector('.swiper-pagination'),
                        clickable: true,
                    },
                    on: {
                        slideChange: function () {
                            updateActiveBullet(this);
                        },
                    },
                });
                carousel.swiperInstance = swiper;
            });

            function updateActiveBullet(swiperInstance) {
                const paginationEl = swiperInstance.pagination.el;
                const paginationBullets = paginationEl ? paginationEl.querySelectorAll('.swiper-pagination-bullet') : null;

                if (paginationBullets) {
                    paginationBullets.forEach((bullet) => bullet.classList.remove('swiper-pagination-bullet-active'));

                    const realIndex = swiperInstance.realIndex + 1;
                    const activeBullet = paginationEl.querySelector(`.swiper-pagination-bullet:nth-child(${realIndex})`);
                    if (activeBullet) {
                        activeBullet.classList.add('swiper-pagination-bullet-active');
                    }
                }
            }
        }
    }

    initializeSwipers();

    document.addEventListener('collection-rendred', reinitializeSwipers);
    document.addEventListener('recommendation-rendred', reinitializeSwipers);
    
    function reinitializeSwipers() {
        document.querySelectorAll('.swiper-container').forEach((carousel) => {
            carousel.swiperInstance?.destroy(true, true);
        });
        initializeSwipers();
    }  
});
